var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { DurationUnit } from '../models/squareup/sub2/duration';
import { Duration as Sub2Duration } from '@square/dashboard-protos/models/squareup/sub2/data';
import { assert } from '@ember/debug';
let DurationHelper = (_class = class DurationHelper extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  // TODO: Rename this and formatUnitCycle. Don't know what to call them.
  formatUnitPrepay(unit) {
    switch (unit) {
      case DurationUnit.DAY:
      case Sub2Duration.DurationUnit.DAY:
        return this.intl.t('subscriptions.sub2.billingCycle.prepayDaily');
      case DurationUnit.MONTH:
      case Sub2Duration.DurationUnit.MONTH:
        return this.intl.t('subscriptions.sub2.billingCycle.prepayMonthly');
      case DurationUnit.YEAR:
      case Sub2Duration.DurationUnit.YEAR:
        return this.intl.t('subscriptions.sub2.billingCycle.prepayYearly');
      default:
        assert('Invalid Billing Cycle');
        return null;
    }
  }
  formatUnitCycle(unit) {
    switch (unit) {
      case DurationUnit.DAY:
      case Sub2Duration.DurationUnit.DAY:
        return this.intl.t('subscriptions.sub2.renewalCycle.day');
      case DurationUnit.MONTH:
      case Sub2Duration.DurationUnit.MONTH:
        return this.intl.t('subscriptions.sub2.renewalCycle.month');
      case DurationUnit.YEAR:
      case Sub2Duration.DurationUnit.YEAR:
        return this.intl.t('subscriptions.sub2.renewalCycle.year');
      default:
        assert('Invalid renewal cycle');
        return null;
    }
  }
  formatUnitCycleAbbreviated(unit) {
    switch (unit) {
      case DurationUnit.DAY:
      case Sub2Duration.DurationUnit.DAY:
        return this.intl.t('subscriptions.sub2.renewalCycleAbbreviated.day');
      case DurationUnit.MONTH:
      case Sub2Duration.DurationUnit.MONTH:
        return this.intl.t('subscriptions.sub2.renewalCycleAbbreviated.month');
      case DurationUnit.YEAR:
      case Sub2Duration.DurationUnit.YEAR:
        return this.intl.t('subscriptions.sub2.renewalCycleAbbreviated.year');
      default:
        assert('Invalid renewal cycle');
        return null;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DurationHelper as default };